import { Box } from '@chakra-ui/react';
import { ClientVisits } from 'types/client';
import VisitItem from './VisitItem'; // Assurez-vous que le chemin d'importation est correct

const VisitsList: React.FC<ClientVisits> = ({ visits }) => {
  // Les 4 futures visites
  const visitsWithoutCrossRegionVisit = visits?.filter((visit) => visit.VisitType !== -1);
  const nextVisits = visitsWithoutCrossRegionVisit.slice(0, 4);
  // Les visites restants à afficher dans l'accordéon
  // const remainingVisits = visits.slice(2);

  return (
    <>
      <Box w="full" padding={'1em'} className="accountVisits">
        {nextVisits.map((visit) => (
          <VisitItem key={visit.Id} futureVisit={visit} />
        ))}
      </Box>

      {/* Affichage de l'accordéon pour les services supplémentaires si nécessaire */}
      {/*
      {remainingVisits.length > 0 && (
        <Accordion allowToggle w="full" mt={5}>
          <AccordionItem>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                <Text>Voir toutes les prochaines sessions</Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel padding={0}>
              {remainingVisits.map((visit, index) => (
                <VisitItem key={index} futureVisit={visit} />
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
      */}
    </>
  );
};

export default VisitsList;
